// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1QS1u","right":"styles_right__2NA8I"};